// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-info {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  background: #f3f5f7;
  border-radius: 20px;
  margin-top: 40px;
}
.payment-info .stripe-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.payment-info .stripe-elements {
  display: flex;
  flex-direction: column;
  margin: 10vh 0;
  justify-content: center;
  padding: 20px;
  width: 40%;
  border-radius: 24px;
  background: #FEFEFE;
  box-shadow: 0px 40px 64px -16px rgba(0, 0, 0, 0.15), 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
}
.payment-info .stripe-elements .plan-opt {
  list-style-type: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-bottom: 50px;
}
.payment-info .plan-discriminator {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-right: 50px;
  width: 250px;
  padding-top: 140px;
}
.payment-info .plan-discriminator .plan-container {
  font-weight: 600;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}
.payment-info .plan-discriminator .plan-container .plan-badge {
  font-size: 12px;
  line-height: 24px;
  background-color: #ff97e8;
  color: #141718;
  width: 68px;
  height: 24px;
  padding: 0px 12px 0px 12px;
  border-radius: 4px;
  gap: 8px;
}
.payment-info .plan-discriminator .plan-section {
  display: flex;
  flex-direction: row;
}
.payment-info .plan-discriminator .plan-section .plan-price {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: center;
  margin-right: 20px;
}
.payment-info .plan-discriminator .plan-section .plan-periodicity {
  color: #6c7275;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: center;
}
.payment-info .plan-discriminator .divider {
  border-top: 1px solid rgba(0, 0, 0, 0.1019607843);
  margin: 15px 0px;
}
.payment-info .plan-discriminator .plan-benefits-icon {
  color: #0084ff;
  padding-right: 10px;
  display: block;
  padding-top: 4px;
}
.payment-info .plan-discriminator .plan-benefits-icon .svg-inline--fa {
  height: 20px;
}
.payment-info .plan-discriminator .plan-benefits-text {
  color: #141718;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.01em;
  text-align: left;
}
.payment-info .plan-lock {
  color: #0c923c;
  margin-right: 10px;
}
.payment-info .pay-resume {
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}
.payment-info .pay-resume .pay-resume-text {
  font-size: 28px;
  font-weight: 700;
  line-height: 40px;
}
.payment-info .no-margin-bottom {
  margin-bottom: 0;
}
.payment-info .promo-container {
  display: flex;
  flex-direction: column;
}
.payment-info .pay-promocode {
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}
.payment-info .pay-promocode .button-link {
  display: flex;
  flex-direction: row-reverse;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: right;
  text-decoration: none;
}
.payment-info .pay-promocode .pay-resume-text {
  font-size: 28px;
  font-weight: 700;
  line-height: 40px;
}
.payment-info .pay-text {
  text-align: right;
  margin-bottom: 20px;
  font-size: 11px;
  width: 100%;
  padding-left: 100px;
  color: #B6B8B9;
}
.payment-info .pay-btn {
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.payment-info .pay-btn button {
  font-size: 15px;
  font-weight: 600;
  padding: 8px 20px;
  border-radius: 12px;
}
.payment-info .plan-lock-instruction {
  color: #6c7275;
  font-size: 12px;
}
.payment-info .paymentinfo-option {
  padding: 20px;
  border-radius: 20px;
  border: 1px solid #000;
}
.payment-info .paymentinfo-option.best-option {
  color: #fff;
  background-color: #000;
}
.payment-info .paymentinfo-option .paymentinfo-periodicity {
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 40px;
  letter-spacing: -0.01em;
  color: rgba(108, 114, 117, 0.5);
}
.payment-info .paymentinfo-option .popular-opt {
  gap: 8px;
  background: #ff97e8;
  border-radius: 4px;
  color: #141718;
}
.payment-info .paymentinfo-opt {
  list-style-type: none;
}
.payment-info .periodicity-opt {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.item-plan {
  display: flex;
  align-items: center;
  align-content: center;
  flex-direction: row;
  margin-bottom: 4px;
}

.selected-plan .plan-name {
  color: #139843;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.48px;
}`, "",{"version":3,"sources":["webpack://./src/Components/PaymentInfo/PaymentInfo.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,wFAAA;AAAJ;AAEI;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;AAAN;AAIE;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAFJ;AAII;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;AAFN;AAKM;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EAEA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,QAAA;AAJR;AAQI;EACE,aAAA;EACA,mBAAA;AANN;AAQM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AANR;AASM;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;AAPR;AAWI;EACE,iDAAA;EACA,gBAAA;AATN;AAYI;EACE,cAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAVN;AAaI;EACE,YAAA;AAXN;AAcI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AAZN;AAgBE;EACE,cAAA;EACA,kBAAA;AAdJ;AAiBE;EACE,aAAA;EACA,2BAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAfN;AAmBE;EACE,gBAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,sBAAA;AAlBJ;AAqBE;EACE,aAAA;EACA,2BAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;AAnBJ;AAqBI;EACE,aAAA;EACA,2BAAA;EAEA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,qBAAA;AApBN;AAuBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AArBN;AAyBE;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AAvBJ;AA0BE;EACE,aAAA;EACA,2BAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;AAxBJ;AA2BE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAzBJ;AA4BE;EACE,cAAA;EACA,eAAA;AA1BJ;AA6BE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AA3BJ;AA6BI;EACE,WAAA;EACA,sBAAA;AA3BN;AA8BI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,+BAAA;AA5BN;AA+BI;EACE,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AA7BN;AAiCE;EACE,qBAAA;AA/BJ;AAkCE;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AAhCJ;;AAoCA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;AAjCF;;AAoCA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAjCF","sourcesContent":[".payment-info {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  background: #f3f5f7;\n  border-radius: 20px;\n  margin-top: 40px;\n\n  .stripe-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n  }\n\n  .stripe-elements {\n    display: flex;\n    flex-direction: column;\n    margin: 10vh 0;\n    justify-content: center;\n    padding: 20px;\n    width: 40%;\n    border-radius: 24px;\n    background: #FEFEFE;\n    box-shadow: 0px 40px 64px -16px rgba(0, 0, 0, 0.15), 0px 0px 4px 0px rgba(0, 0, 0, 0.05);\n\n    .plan-opt {\n      list-style-type: none;\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      justify-content: space-around;\n      margin-bottom: 50px;\n    }\n  }\n\n  .plan-discriminator {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    padding-right: 50px;\n    width: 250px;\n    padding-top: 140px;\n\n    .plan-container {\n      font-weight: 600;\n      display: flex;\n      flex-direction: row;\n      flex-wrap: nowrap;\n      justify-content: space-between;\n      align-items: center;\n\n\n      .plan-badge {\n        font-size: 12px;\n        line-height: 24px;\n        background-color: #ff97e8;\n        color: #141718;\n\n        width: 68px;\n        height: 24px;\n        padding: 0px 12px 0px 12px;\n        border-radius: 4px;\n        gap: 8px;\n      }\n    }\n\n    .plan-section {\n      display: flex;\n      flex-direction: row;\n\n      .plan-price {\n        font-family: Inter;\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 24px;\n        letter-spacing: -0.02em;\n        text-align: center;\n        margin-right: 20px;\n      }\n\n      .plan-periodicity {\n        color: #6c7275;\n        font-family: Inter;\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 24px;\n        letter-spacing: -0.02em;\n        text-align: center;\n      }\n    }\n\n    .divider {\n      border-top: 1px solid #0000001a;\n      margin: 15px 0px;\n    }\n\n    .plan-benefits-icon {\n      color: #0084ff;\n      padding-right: 10px;\n      display: block;\n      padding-top: 4px;\n    }\n\n    .plan-benefits-icon .svg-inline--fa {\n      height: 20px;\n    }\n\n    .plan-benefits-text {\n      color: #141718;\n      font-family: Inter;\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 24px;\n      letter-spacing: -0.01em;\n      text-align: left;\n    }\n  }\n\n  .plan-lock {\n    color: #0c923c;\n    margin-right: 10px;\n  }\n\n  .pay-resume {\n    display: flex;\n    flex-direction: row-reverse;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 20px;\n\n    .pay-resume-text {\n      font-size: 28px;\n      font-weight: 700;\n      line-height: 40px;\n    }\n  }\n\n  .no-margin-bottom {\n    margin-bottom: 0;\n  }\n\n  .promo-container {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .pay-promocode {\n    display: flex;\n    flex-direction: row-reverse;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 20px;\n\n    .button-link {\n      display: flex;\n      flex-direction: row-reverse;\n\n      font-family: Inter;\n      font-size: 14px;\n      font-weight: 600;\n      line-height: 24px;\n      letter-spacing: -0.02em;\n      text-align: right;\n      text-decoration: none;\n    }\n\n    .pay-resume-text {\n      font-size: 28px;\n      font-weight: 700;\n      line-height: 40px;\n    }\n  }\n\n  .pay-text {\n    text-align: right;\n    margin-bottom: 20px;\n    font-size: 11px;\n    width: 100%;\n    padding-left: 100px;\n    color: #B6B8B9\n  }\n\n  .pay-btn {\n    display: flex;\n    flex-direction: row-reverse;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: center;\n  }\n\n  .pay-btn button {\n    font-size: 15px;\n    font-weight: 600;\n    padding: 8px 20px;\n    border-radius: 12px;\n  }\n\n  .plan-lock-instruction {\n    color: #6c7275;\n    font-size: 12px;\n  }\n\n  .paymentinfo-option {\n    padding: 20px;\n    border-radius: 20px;\n    border: 1px solid #000;\n\n    &.best-option {\n      color: #fff;\n      background-color: #000;\n    }\n\n    .paymentinfo-periodicity {\n      font-style: normal;\n      font-weight: 700;\n      font-size: 28px;\n      line-height: 40px;\n      letter-spacing: -0.01em;\n      color: rgba(108, 114, 117, 0.5);\n    }\n\n    .popular-opt {\n      gap: 8px;\n      background: #ff97e8;\n      border-radius: 4px;\n      color: #141718;\n    }\n  }\n\n  .paymentinfo-opt {\n    list-style-type: none;\n  }\n\n  .periodicity-opt {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n  }\n}\n\n.item-plan {\n  display: flex;\n  align-items: center;\n  align-content: center;\n  flex-direction: row;\n  margin-bottom: 4px;\n}\n\n.selected-plan .plan-name {\n  color: #139843;\n  font-family: Inter;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 40px;\n  letter-spacing: -0.48px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
